import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'

export const Root = styled.div`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const DesktopNavigation = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: center;
    margin: 0;
  }
`
export const SubTitle = styled.h1`
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: 600;
  width: ${props => props.width};

  ${props => props.theme.breakpoints.down('xs')} {
    text-align: center;
  }
`

export const Divided = styled.hr`
  width: ${props => props.width || 'auto'};
  border: 1px solid ${props => props.theme.palette.gray[90]};
  margin: ${props => props.margin};
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 32px;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth};
  padding: ${props => props.padding || 'initial'};
`

export const Strong = styled.span`
  font-weight: bold;
`

export const Title = styled.h1`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Instructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const ExternalLink = styled.a`
  color: ${props => props.theme.palette.brand.primary};

  &:hover {
    text-decoration: underline;
  }
`
